import React from 'react';
import { View, Text } from 'react-native';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const QrCodeConfirmPay = () => {
    return (
        <>
            <HeaderDefault title={<FormattedMessage id='qrCodeConfirmPay.headerQrCode'/>} />

            <View style={styles.container}>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='qrCodeConfirmPay.txtValorPagamento'/></Text>
                    <Text><FormattedMessage id='qrCodeConfirmPay.txtValorPagamentoBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='qrCodeConfirmPay.txtMoeda'/></Text>
                    <Text><FormattedMessage id='qrCodeConfirmPay.txtGpxToken'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='qrCodeConfirmPay.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='qrCodeConfirmPay.txtNome'/></Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='qrCodeConfirmPay.btnContinuar'/>} titlePage={<FormattedMessage id='qrCodeConfirmPay.btnContinuaPagamento'/>} />
        </>
    );
}
export default QrCodeConfirmPay;